var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "admin-base-layout",
    [
      _c("template", { slot: "admin-page-header" }, [
        _c("div", { staticClass: "flex-wrap-spacing" }, [
          _c("h3", { staticClass: "page-header" }, [_vm._v("Quotas")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "admin-page-content" },
        [
          !_vm.quotas ? _c("loader") : _vm._e(),
          _vm._v(" "),
          _vm.quotas && _vm.quotas.length > 0
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 pad0" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      { staticClass: "table table-hover tests_quotas_table" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Type")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Used")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Reset")]),
                            _vm._v(" "),
                            _c("th")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.quotas, function(quota) {
                            return _c("tr", { key: quota.name }, [
                              _c("td", { staticClass: "tests_quota_name" }, [
                                _vm._v(_vm._s(quota.name))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "tests_quota_value" }, [
                                _vm._v(
                                  _vm._s(quota.value) +
                                    " / " +
                                    _vm._s(quota.max)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "tests_quota_ttl" }, [
                                quota.ttl
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("duration")(
                                            [quota.ttl, "seconds"],
                                            "humanize",
                                            true
                                          )
                                        )
                                      )
                                    ])
                                  : _c("span", [_vm._v("-")])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "quota_gauge_col" }, [
                                _c("div", { staticClass: "gauge" }, [
                                  _c("div", {
                                    staticClass: "gauge-used",
                                    style: {
                                      width:
                                        (quota.value / quota.max) * 100 + "%"
                                    }
                                  })
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      parseInt((quota.value / quota.max) * 100)
                                    ) +
                                    "%\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32a841ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a841ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quotas.vue
// module id = null
// module chunks = 